export default __webpack_public_path__ + "static/media/mobile_icon.fd162aac.svg";